<template>
  <div class="relationship-run-explain">
    <div v-if="text">
      <span class="relationship-run-explain__key">{{ label }}</span>{{ text }}
    </div>
    <div v-if="action">
      <span class="relationship-run-explain__key">What you can do</span>{{ action }}
    </div>
    <div v-if="code"><relationship-code-detail :code="code" /></div>
  </div>
</template>

<script>
import RelationshipCodeDetail from './RelationshipCodeDetail.vue';

// Expanded-row explanation under a refused or changed-link row: reason, next step, code.
export default {
  name: 'RelationshipRunExplain',
  components: { RelationshipCodeDetail },
  props: {
    label: { type: String, default: 'Why' },
    text: { type: String, default: '' },
    action: { type: String, default: '' },
    code: { type: String, default: '' },
  },
};
</script>

<style lang="scss" scoped>
.relationship-run-explain {
  display: grid;
  max-width: 900px;
  gap: 6px;
  padding: 10px var(--ds-space-md) 12px 52px;
  font-size: var(--ds-font-body-sm);
  line-height: 1.55;
}
.relationship-run-explain__key {
  display: block;
  color: var(--run-muted-ink, #5c6b66);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

@media (max-width: 720px) {
  .relationship-run-explain { padding-left: var(--ds-space-md); }
}
</style>
